import "leaflet/dist/leaflet.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import DirectoryPage from "@/pages/DirectoryPage";
import FacilityDetailPage from "@/pages/FacilityDetailPage";

function App() {
  return (
    <div className="min-h-screen bg-white text-[#09090B]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<DirectoryPage />} />
          <Route path="/facility/:facilityId" element={<FacilityDetailPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
